module.exports = __webpack_public_path__ + "static/img/m-H1C.446bfe9b.png";